import { render, staticRenderFns } from "./BasesList.vue?vue&type=template&id=a9aaf5be&scoped=true&"
import script from "./BasesList.vue?vue&type=script&lang=js&"
export * from "./BasesList.vue?vue&type=script&lang=js&"
import style0 from "./BasesList.vue?vue&type=style&index=0&id=a9aaf5be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9aaf5be",
  null
  
)

export default component.exports